(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mthecat-purchase-ux"] && !Shopify.designMode) return;
  try {
    const initializeMthecatCart = () => {
    const cart = document.querySelector('sticky-cart.mthecat-purchase');
    const trigger = document.querySelector('.mthecat-purchase sticky-cart-trigger');
    if (!cart || !trigger) return;
    const update = () => {
      const visible = trigger.getBoundingClientRect().top < 0;
      cart.classList.toggle('is-sticky', visible);
      cart.classList.toggle('is-visible', visible);
      document.body.style.paddingBottom = visible ? `${cart.getBoundingClientRect().height}px` : '0px';
    };
    new IntersectionObserver(update, { threshold: 1 }).observe(trigger);
    new ResizeObserver(update).observe(cart);
    let scheduled = false;
    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        update();
      });
    }, { passive: true });
    update();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMthecatCart, { once: true });
  } else {
    initializeMthecatCart();
  }
  document.addEventListener('submit', (event) => {
    if (!event.target.closest('sticky-cart.mthecat-purchase')) return;
    const mainForm = document.querySelector('product-info.mthecat-purchase[id^="MainProduct"] product-form form');
    const mainButton = mainForm?.querySelector('button[name="add"]');
    if (!mainForm || !mainButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!mainButton.disabled) mainForm.requestSubmit(mainButton);
  }, true);
  document.addEventListener('change', (event) => {
    const source = event.target.closest('variant-selects');
    if (!source || !source.closest('.mthecat-purchase')) return;
    const value = event.target.value;
    const summary = document.querySelector('sticky-cart.mthecat-purchase .accordion__title-variant');
    if (summary) summary.textContent = value.split('(')[0].trim();
    document.querySelectorAll('.mthecat-purchase variant-selects').forEach((picker) => {
      if (picker === source) return;
      const select = picker.querySelector('select');
      if (select && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!select) {
        const radio = Array.from(picker.querySelectorAll('input[type=radio]')).find((input) => input.value === value);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
